import React from 'react';
import PropTypes from 'prop-types';

export default class Ui5MultiselectOptions extends React.Component {
    static propTypes = {
        typeFilterValues: PropTypes.array.isRequired,
        lockedValues: PropTypes.array,

        // Form
        form: PropTypes.object,
        name: PropTypes.string,

        obligatoryItemsNum: PropTypes.number,
    }

    static defaultProps = {
        obligatoryItemsNum: 1
    }

    constructor(props) {
        super(props);

        this.state = this._getState(props);

        if (this.props.form) this.props.form.registerFormComponent(this.props.name,this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState(this._getState(nextProps));
    }

    _addLockedValues = (values) => {
        return this.props.lockedValues ? _.uniq([].concat(values).concat(this.props.lockedValues)) : values;
    }

    _getState(props) {
        let filterTypes = props.form.getValue(props.name);
        if (!filterTypes) filterTypes = [];

        return {
            filterTypes: this._addLockedValues(filterTypes)
        };
    }

    onItemClick = (value) => {
        if (this.props.lockedValues &&
            this.props.lockedValues.includes(value) &&
            this.state.filterTypes.includes(value)) return; //this value is not allowed to remove

        const newTypes = gd.utils.toggleArrayValue(this.state.filterTypes, value);

        if (newTypes.length >= this.props.obligatoryItemsNum) {
            if (this.props.form) this.props.form.onFormComponentValueChange(this.props.name, newTypes);

            this.setState({
                filterTypes: this._addLockedValues(newTypes)
            });
        }
    };

    render() {
        const value = this.props.form.getValue(this.props.name);

        return (
            <div className={Classes("fl-ac", this.props.className)}>
                {this.props.typeFilterValues.map(v=>{
                    const isSelected = value && value.includes(v.value);
                    const isDisabled = v.disabled || (this.props.lockedValues && this.props.lockedValues.includes(v.value))

                    return (
                        <div key={v.value} className="fl-ac" onClick={!isDisabled ? this.onItemClick.bind(this,v.value) : null}>
                            <div className={Classes("ui5-cb","s-13", {selected: isSelected})}/>
                            <div className="m-l-8 ui5-txt-default m-r-20">{v.label}</div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
